import React from "react";
import "./style.css";
import Card from "react-bootstrap/Card";
import "bootstrap/dist/css/bootstrap.min.css";

export const BillingMonthly = ({ data }) => {
    return (
        <Card style={{borderRadius:"0px"}}>
            <Card.Header>
                <Card.Title>Monthly</Card.Title>
            </Card.Header>
            <Card.Body>
                {!!data?.length > 0 ? (
                    data?.map((o, index) => (
                        <Card>
                            <Card.Header>
                                <span>Year: {o?.year}</span>
                                <span className="padding-left-20px">
                                    Timestamp: {o?.timestamp}
                                </span>
                                <span className="padding-left-20px">Month: {o?.month}</span>
                                <span className="padding-left-20px">
                                    Total cost: {o?.totalCost}
                                </span>
                            </Card.Header>
                            <Card.Body>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">App</th>
                                            <th scope="col">Method</th>
                                            <th scope="col">Count</th>
                                            <th scope="col">Cost</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {o?.billingInfo.map((b, bIndex) =>
                                            b?.estimation.map((e, eIndex) => (
                                                <tr>
                                                    <td>{b?.app}</td>
                                                    <td>{e?.method}</td>
                                                    <td>{e?.count}</td>
                                                    <td>{e?.cost}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </Card.Body>
                        </Card>
                    ))
                ) : (
                    <div>No billing data found</div>
                )}
            </Card.Body>
        </Card>
    );
};
